import {GridPhoto} from 'platform/components';

import {isEmpty} from 'ramda';

import {Nullish} from 'shared/web';

import {Video} from '../../VideoPreview/types/video';

export type ServiceCaseAuditData = {
  checkinPhotos: GridPhoto[];
  checkinVideos: Video[];
  handoverPhotos: GridPhoto[];
  handoverVideos: Video[];
  checkinAuditId: string | Nullish;
  handoverAuditId: string | Nullish;
};

export const isServiceCaseAuditDataEmpty = (data: ServiceCaseAuditData): boolean =>
  isEmpty(data.checkinPhotos) &&
  isEmpty(data.checkinVideos) &&
  isEmpty(data.handoverPhotos) &&
  isEmpty(data.handoverVideos);
